define(['underscore', 'edge/platform/base/BaseCtrl'], (_, BaseCtrl)=> {
    const fn = ($filter, $scope, $translate, $anchorScroll, ModalService, StateUtils, submissionViewModel, editableDriverDOB, $rootScope, availableYears, InMemorySession,InputValidationService)=> {
        const ctrl = Object.create(BaseCtrl);
        const flowModel = StateUtils.activeDataForState(true).flowModel;
        const submissionVm = submissionViewModel();
        const paModel = submissionVm.draftData.lobs.personalAuto.value;
        const paModelVM = submissionVm.draftData.lobs.personalAuto
        const accountHolder = submissionVm.value.getAccountHolderPerson();
       

        ctrl.init = ()=> {
            // Scroll to top of page 
            $anchorScroll();
            //ENHC0013007 -- Insurance Premium Refunds --Arpita
            $scope.isNameValid = true
            //ended
            $scope.page = {
                readonly: false
            };
            let selectedVehicle;

            $scope.vehicles = paModel.vehicles;
            $scope.drivers = paModel.drivers;
            $scope.quoteID = submissionVm.quoteID;
            
            //populate vehicle primary usage
            for(var idx in paModel.vehicles){
                var vehicle = paModel.vehicles[idx];
                //devendra prefill code start
                if(!paModel.vehicles[idx].vin && paModel.vehicles[idx].encryptedVIN){
                    paModel.vehicles[idx].vin = paModel.vehicles[idx].encryptedVIN
                }
                prefillVehicleCheck(vehicle,parseInt(idx));
                //devendra prefill code end
                if (vehicle.primaryUse != undefined){

                    //$scope.vehicle.tmpPrimeUse.value = "less10"
                    if (vehicle.primaryUse == "commuting") {                        
                        if (vehicle.commutingMiles == 5){
                            vehicle.tmpPrimeUse = "less10";
                        }else if (vehicle.commutingMiles == 15){
                            vehicle.tmpPrimeUse = "more10";
                        }                            
                    } else if (vehicle.primaryUse == "pleasure"){
                        vehicle.tmpPrimeUse = "Personal";
                    } else{
                        vehicle.tmpPrimeUse = "Business";
                    }
                }
            }
            
            // Populate available year list from resolve, populate the list
            // and pass on to vehicle directive -> PAEdiVehicle.js
            $scope.availableYears = [];
            if (availableYears.jsonOutputString){// check for valid server response
                var availYearArr = JSON.parse("[" + availableYears.jsonOutputString + "]");
                for (var idx = 0; idx < availYearArr[0].length; idx++){
                    var year = availYearArr[0][idx];
                    $scope.availableYears.push(parseInt(year.trim()));
                }
            }
             
            /**
             *  If there are no vehicles in the table, initialise an empty vehicle to be populated,
             *  otherwise on first enter, when there are vehicles, pick the first one from the array.
             */
            if (paModel.vehicles.length === 0) {
                selectedVehicle = paModel.createVehicle(accountHolder);
            } else {
                selectedVehicle = paModel.vehicles[0];
            }
            
          
            //This function is used to remove prefill data needed to obtain a quote for streamlined submissions.
            const sanitisePrefillDataFromQuickQuote = (vehicles) => {
                const vehicle = _.findWhere(vehicles, {license: '0streamlinedquote0'});
                if (angular.isDefined(vehicle)) {
                    vehicle.license = undefined;
                    vehicle.costNew.amount = undefined;
                    if (vehicle.vin === '0streamlinedquote0') {
                        vehicle.vin = undefined;
                    }
                }
            };
            sanitisePrefillDataFromQuickQuote(paModel.vehicles);

            $scope.page.selectedVehicle = submissionVm.draftData.lobs.personalAuto.vehicles.findFirstElement(selectedVehicle);
        };

        function validateInputs (inputsToValidate, scopeVar) {
            let inputValidationData = [];
            inputValidationData = InputValidationService.isInputValid(inputsToValidate)
            if(!inputValidationData[0] && inputValidationData[1].length > 0){
                for (let i=0; i<inputValidationData[1].length; i++){
                    scopeVar[inputValidationData[1][i]] = ''
                    $scope.isNameValid = false;
                }
            }else{
                $scope.isNameValid = true;
            }
        }
        ctrl.addVehicle = (form)=> {
            if (ctrl._isValid(form)) {
                //ENHC0013007 -- Insurance Premium Refunds --Arpita
                if($scope.page.selectedVehicle.value.addnlInterest != undefined){
                    let inputsToValidate = [
                        {'name' : $scope.page.selectedVehicle.value.addnlInterest.name},
                        {'addnlInterestAddress.addressLine1' : $scope.page.selectedVehicle.value.addnlInterest.addnlInterestAddress.addressLine1},
                        {'addnlInterestAddress.addressLine2' : $scope.page.selectedVehicle.value.addnlInterest.addnlInterestAddress.addressLine2},
                        {'addnlInterestAddress.city' : $scope.page.selectedVehicle.value.addnlInterest.addnlInterestAddress.city}
                    ];
                    validateInputs(inputsToValidate,$scope.page.selectedVehicle.value.addnlInterest)
                    if(!$scope.isNameValid){
                        return
                    }
                }
                //ended
                const newVehicle = paModel.createVehicle();
                $anchorScroll();
                $scope.page.selectedVehicle = submissionVm.draftData.lobs.personalAuto.vehicles.findFirstElement(newVehicle);
                $scope.page.readonly = false;
                $scope.$broadcast('update-form');
                form.submitted = false;
                form.setPristine();
                form.$setUntouched();
            }
        };
        //devendra prefill code start
        function prefillVehicleCheck(vehicle,index){
            var prefillResponseFromFactory = InMemorySession.getPrefillData();
            if(prefillResponseFromFactory!== "undefined" && typeof prefillResponseFromFactory.vehicles !== "undefined" && prefillResponseFromFactory.vehicles.length >0){
                prefillResponseFromFactory.vehicles.forEach((obj) => {
                    if(obj.vin == vehicle.vin || obj.vin == InMemorySession.encryptData(vehicle.vin)){
                        $scope.vehicles[index].isPrefilledVehicle = true;
                        paModel.vehicles[index].encryptedVIN = paModel.vehicles[index].encryptedVIN? paModel.vehicles[index].encryptedVIN : paModel.vehicles[index].vin ;
                        paModel.vehicles[index].vin = InMemorySession.decryptData(paModel.vehicles[index].vin);
                    }        
                });
            }
        };
        //devendra prefill code end

        ctrl.removeVehicle = (vehicle)=> {
            const confirmationMsg = {
                key: 'quoteandbind.pa.controllers.PAVehicleDetailsCtrl.RemoveConfirmationMsg',
                args: {vehicle: vehicle.getDisplayName(undefined, $filter)}
            };
            ModalService.showWarning('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Remove vehicle?', confirmationMsg, '',
                $filter('translate')('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Yes'),
                'gw-btn-primary',
                $filter('translate')('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.No'))
                .result.then(()=> {
                let vehicleObj;
                if (submissionVm.draftData.lobs.personalAuto.vehicles.findFirstElement(vehicle) === $scope.page.selectedVehicle) { //If we're about to delete the current vehicle, show the first vehicle or blank
                    if (paModel.vehicles.length > 1) {
                        if (paModel.vehicles[0] !== vehicle) {
                            vehicleObj = paModel.vehicles[0];
                        } else {
                            vehicleObj = paModel.vehicles[1];
                        }
                    }
                } else {
                    vehicleObj = $scope.page.selectedVehicle.value;
                }
                paModel.removeVehicle(vehicle);
                $scope.page.selectedVehicle = submissionVm.draftData.lobs.personalAuto.vehicles.findFirstElement(vehicleObj);
                $scope.$broadcast('update-form');
            });
        };

        ctrl.isVehicleValid = (form)=> {
            form.submitted = true;
        if($scope.page.selectedVehicle.tmpPrimeUse.value === undefined ||$scope.page.selectedVehicle.tmpPrimeUse.value=== null){
            return false;
        }
        if($scope.page.selectedVehicle.tmpPaType.value == "auto" &&
            ($scope.page.selectedVehicle.comprehensiveSymbolCd.value === undefined || $scope.page.selectedVehicle.comprehensiveSymbolCd.value == "") &&
            ($scope.page.selectedVehicle.collisionSymbolCd.value === undefined || $scope.page.selectedVehicle.collisionSymbolCd.value == "") &&
            ($scope.page.selectedVehicle.twoDgVSRSymbol.value === undefined || $scope.page.selectedVehicle.twoDgVSRSymbol.value == "") &&
            ($scope.page.selectedVehicle.costNew.amount.value === undefined || $scope.page.selectedVehicle.costNew.amount.value == "")){
            return false;
        }
        if($scope.page.selectedVehicle.tmpPaType.value == "motorcycle_aaa" &&
            ($scope.page.selectedVehicle.costNew.amount.value === undefined || $scope.page.selectedVehicle.costNew.amount.value == "")){
            return false;
        }
        if($scope.page.selectedVehicle.tmpPaType.value == "auto" && ($scope.page.selectedVehicle.tmpOwnership.value =="additionalinterest_aaa" || $scope.page.selectedVehicle.tmpOwnership.value =="LOSSP" && $scope.page.selectedVehicle.tmpOwnership.value != "Own") &&
            (($scope.page.selectedVehicle.addnlInterest.name.value.trim() === undefined || $scope.page.selectedVehicle.addnlInterest.name.value.trim() == "") ||
            ($scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.addressLine1.value.trim() === undefined || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.addressLine1.value.trim() == "") ||
            ($scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.postalCode.value.trim() === undefined || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.postalCode.value.trim() == "") ||
            ($scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.city.value.trim() === undefined || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.city.value.trim() == "") ||
            ($scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.state.value === undefined || $scope.page.selectedVehicle.addnlInterest.addnlInterestAddress.state.value == ""))){
            return false;
        }
            return $scope.page.selectedVehicle.aspects.subtreeValid;
        };

            ctrl.editVehicle = (vehicle, form, rowIndex)=> { //Validate the current input, and if correct, save the current changes and select the next vehicle
            $scope.selectedRow = rowIndex; // for highlighting selected row
            if (ctrl._isValid(form)) {
                $scope.page.selectedVehicle = submissionVm.draftData.lobs.personalAuto.vehicles.findFirstElement(vehicle);
               
            } else {
                form.submitted = true;
            }
            $scope.page.readonly = false;
        };

        ctrl._isValid = (form)=> {
            if (!ctrl.isVehicleValid(form)) {
                form.submitted = true;
                return false;
            }
            const licenceMatchedVehicle = ctrl._ensureUniqueLicensePlate($scope.page.selectedVehicle.value);
            const vinMatchedVehicle = ctrl._ensureUniqueVin($scope.page.selectedVehicle.value);
           /* if (licenceMatchedVehicle) {
                const licenceMatchedMsg = $translate('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.LicenceMatchMsg', {licenceMatchedVehicle: licenceMatchedVehicle.getDisplayName(undefined, $filter)});
                ModalService.showError('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Licence plate is not unique', licenceMatchedMsg);
                return false;
            } else*/ if (vinMatchedVehicle) {
                const vinMatchedMsg = $translate('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.VinMatchMsg', {vinMatchedVehicle: vinMatchedVehicle.getDisplayName(undefined, $filter)});
                ModalService.showWarning('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.VIN is not unique', vinMatchedMsg);
                return false;
            }
            return true;
        };

        ctrl._ensureUniqueLicensePlate = (vehicle)=> {
            const vehicleMatch = _.where(paModel.vehicles, {license: vehicle.license});
            if (!vehicleMatch) {
                return undefined;
            } else if (vehicleMatch.length === 1) {
                return vehicleMatch[0] !== vehicle ? vehicleMatch : undefined;
            }
            return _.find(vehicleMatch, (v)=> {
                return v !== vehicle;
            });
        };

        ctrl._ensureUniqueVin = (vehicle)=> {
            const vehicleMatch = _.where(paModel.vehicles, {vin: vehicle.vin});
            if (!vehicleMatch) {
                return undefined;
            } else if (vehicleMatch.length === 1) {
                return vehicleMatch[0] !== vehicle ? vehicleMatch : undefined;
            }
            return _.find(vehicleMatch, (v)=> {
                //Added if condition for Defect 861 
                if(v.vin !="" && v.vin != undefined) {
                    return v !== vehicle;
                }
            });
        };

        /*ctrl._setVehicleDefaults = ()=> {
            _.forEach(paModel.vehicles, (vehicle)=> {
                vehicle.primaryUse = 'pleasure';
            });
        };
*/  
        function formatDOB(dobYear, dobMonth, dobDay) {
            let dt = new Date(dobYear, dobMonth, dobDay),
                month  = '' + (dt.getMonth()+1),
                year = '' + dt.getFullYear(),
                day = '' + dt.getDate()

                if (month.length < 2) 
                    month = '0' + month;
                if (day.length < 2) 
                    day = '0' + day;
                let dob = [year, month, day].join('-')
                return dob;
        }
        ctrl.next = function (form) {
            $rootScope.$broadcast('submit-form');
            form.submitted = true;

            if (!ctrl._isValid(form) || form.valid === false) {
                return;
            }

            //ctrl._setVehicleDefaults();

            if (editableDriverDOB) {
                paModel.drivers.forEach((driver)=> {
                    if (driver.person.accountHolder) {
                        submissionVm.draftData.accountHolder.dateOfBirth.value = driver.dateOfBirth;
                    }
                });
            }

            //remove ssnunMasked property
            paModel.drivers.forEach((driver,idx)=> {
                 driver.socialSecurityNumber = driver.ssnunMasked;
                 delete driver["ssnunMasked"]
                // data prefill -- Arpita 
                if(driver.isPrefilledDriver && driver.dateOfBirth){
                    let dob = formatDOB(driver.dateOfBirth.year,driver.dateOfBirth.month,driver.dateOfBirth.day)
                    driver.eNCDateOfBirth = InMemorySession.encryptData(dob).toString();
                    submissionVm.draftData.lobs.personalAuto.drivers.value[idx].eNCDateOfBirth = driver.eNCDateOfBirth
                    submissionVm.draftData.lobs.personalAuto.drivers.value[idx].dateOfBirth = null;
                    driver.dateOfBirth = null;
                    if(submissionVm.draftData.accountHolder.publicID.value !== submissionVm.draftData.lobs.personalAuto.drivers.value[idx].person.publicID){
                        submissionVm.draftData.lobs.personalAuto.drivers.value[idx].person.dateOfBirth = null
                    }
                }
                //ended
             });
            

            // temporary validation added in the front end since driver details are removing whenever we get entity validation exception and then try to proceed.
            if(paModel.vehicles && accountHolder.primaryAddress.state == "SC" && paModel.vehicles.length > 0) {
                 var count =0;
                 _.forEach(paModel.vehicles, (vehicle)=> {
                if(vehicle.tmpPaType == "motorcycle_aaa"){
                    count++;
                   }
                });
                if(count == paModel.vehicles.length){
                  ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Validation Error SC");
                return;
                }
            }
            // Enable this line if want to validate all vehicles form vaild status
            if(paModel.vehicles && paModel.vehicles.length > 1 && !paModelVM.vehicles.aspects.subtreeValid){
                ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-vehicle.Vehicle Validation Error");
                return;
            }
            // data prefill
            if(paModel.vehicles){
                let inputsToValidate = [];
                _.forEach(paModel.vehicles, (vehicle, index)=> {
                    if(vehicle.isPrefilledVehicle){
                        if(vehicle.chosenDriver.dateOfBirth && vehicle.chosenDriver.isPrefilledDriver){
                            let date_of_birth = vehicle.chosenDriver.dateOfBirth;
                            let dob = formatDOB(date_of_birth.year,date_of_birth.month,date_of_birth.day)
                            vehicle.chosenDriver.eNCDateOfBirth = InMemorySession.encryptData(dob).toString();
                            submissionVm.draftData.lobs.personalAuto.vehicles.value[index].chosenDriver.eNCDateOfBirth = vehicle.chosenDriver.eNCDateOfBirth
                            submissionVm.draftData.lobs.personalAuto.vehicles.value[index].chosenDriver.dateOfBirth = null;
                        } 
                        vehicle.vin = null;
                        submissionVm.draftData.lobs.personalAuto.vehicles.value[index].vin = null;
                        if(submissionVm.draftData.lobs.personalAuto.vehicles.value[index].licenseState){
                            submissionVm.draftData.lobs.personalAuto.vehicles.value[index].licenseState = null;
                        }
                    }
                    //ENHC0013007 -- Insurance Premium Refunds --Arpita
                    if(vehicle.addnlInterest != undefined){
                        inputsToValidate.push({'name' : vehicle.addnlInterest.name})                        
                        validateInputs(inputsToValidate,vehicle.addnlInterest)
                        inputsToValidate = []
                        if(!$scope.isNameValid){
                            return;
                        }
                        if(vehicle.addnlInterest.addnlInterestAddress != undefined){
                            inputsToValidate.push({'addressLine1' : vehicle.addnlInterest.addnlInterestAddress.addressLine1},
                            {'addressLine2' : vehicle.addnlInterest.addnlInterestAddress.addressLine2},
                            {'city' : vehicle.addnlInterest.addnlInterestAddress.city})
                            validateInputs(inputsToValidate,vehicle.addnlInterest.addnlInterestAddress)
                            inputsToValidate = []
                            if(!$scope.isNameValid){
                                return;
                            }
                        }
                    }
                });
                if(!$scope.isNameValid){
                    return;
                }//ended
            }
            //ended
            flowModel.next(submissionVm);
        };
        ctrl.previous = function () {
            flowModel.previous(submissionVm);
        };
        ctrl.cancel = function () {
            flowModel.cancel(submissionVm);
        };

        return ctrl.create($scope);
    };
    fn.$inject = ['$filter', '$scope', '$translate', '$anchorScroll', 'ModalService', 'StateUtils', 'submissionViewModel', 'pa.qnb.editableDriverDOB', '$rootScope', 'availableYears','InMemorySession','qnb.InputValidationService'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/pa/controllers/PAVehicleDetailsCtrl.js
 **/